/**
 * Do not edit directly
 * Generated on Monday, August 26, 2024 at GMT-5
 */

exports.Color = {
  "white": "#FFFFFF",
  "cotton": "#FBFBFB",
  "paper": "#F7F7F7",
  "canvas": "#DFE0E1",
  "graphite": "#757575",
  "faireBlack": "#333333",
  "black": "#000000",
  "black3": "rgba(0,0,0,0.03)",
  "black50": "rgba(0,0,0,0.5)",
  "ivory": "#FBF8F6",
  "flax": "#B5A998",
  "espresso": "#585550",
  "blossom": "#F2E5E1",
  "almond": "#E9E0DC",
  "sugar": "#BA9B88",
  "rose": "#D17E70",
  "siren": "#921100",
  "eggplant": "#390D18",
  "ecru": "#F6EEE4",
  "terra": "#AB7456",
  "rust": "#7D3E1E",
  "meringue": "#F6EFDB",
  "sand": "#ECE3D2",
  "cashew": "#D1B985",
  "bamboo": "#A79764",
  "dijon": "#907C3A",
  "marsh": "#595540",
  "soy": "#E9F1E5",
  "birch": "#D9D8CD",
  "field": "#91957B",
  "juniper": "#91A793",
  "fern": "#49694C",
  "thyme": "#3E4023",
  "salt": "#F2F5F5",
  "thistle": "#E2E7F0",
  "taro": "#7A7885",
  "harbor": "#36676A",
  "pacific": "#154548",
  "midnight": "#1B2834",
  "canary": "#FFF0C4",
  "goldenrod": "#FFD781",
  "sunflower": "#F1A706",
  "lawn": "#E2F5AB",
  "periwinkle": "#757575",
  "frosting": "#FFEAE5",
  "coral": "#FC9696",
  "cardinal": "#D43535",
  "ts-matcha": "#DCE3CE",
  "ts-olive": "#50583D",
  "ts-sage": "#8B9478"
}

exports.Font = {
  "family": {
    "serif": "Nantes, Georgia, serif",
    "sans": "Graphik, Helvetica, sans-serif"
  },
  "weight": {
    "regular": 400,
    "medium": 500,
    "semibold": 600
  }
}

exports.Size = {
  "font": {
    "10": "12px",
    "20": "14px",
    "30": "18px",
    "40": "22px",
    "50": "30px",
    "60": "38px",
    "70": "52px",
    "80": "72px"
  },
  "lineHeight": {
    "10": 1.1944444444,
    "20": 1.2307692308,
    "30": 1.2666666667,
    "40": 1.3157894737,
    "50": 1.33333333333,
    "60": 1.4285714286,
    "70": 1.4444444444,
    "80": 1.4545454545
  },
  "letterSpacing": {
    "sans": "0.15px",
    "serif": 0
  }
}
